import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import LandingPage from '../LandingPage';
import { RouteLoadDurationProvider } from '@amzn/awsscm-argo-core/argo/utils/metrics/ArgoRouteLoadDurationContext';
import { NavigableApplicationsObject } from '../RecentApps/types';

interface MainPageProps {
  recentlyUsedLinks: NavigableApplicationsObject[];
  onTogglePinApp?: (app: NavigableApplicationsObject) => void;
  recentAppsLoading: boolean;
  recentAppsError: Error | null;
}

export default function MainPage({ recentlyUsedLinks, onTogglePinApp, recentAppsLoading, recentAppsError }: MainPageProps) {
  return (
    <div className="content">
      <RouteLoadDurationProvider>
        <React.Suspense fallback={<div>Loading...</div>}>
          <Switch>
            <Route 
              path={'/'} 
              exact 
              render={() => (
                <LandingPage 
                  recentlyUsedLinks={recentlyUsedLinks}
                  onTogglePinApp={onTogglePinApp}
                  recentAppsLoading={recentAppsLoading}
                  recentAppsError={recentAppsError}
                />
              )}
            />
            <Route 
              path={'/landing-page'} 
              exact 
              render={() => (
                <LandingPage 
                  recentlyUsedLinks={recentlyUsedLinks}
                  onTogglePinApp={onTogglePinApp}
                  recentAppsLoading={recentAppsLoading}
                  recentAppsError={recentAppsError}
                />
              )}
            />
          </Switch>
        </React.Suspense>
      </RouteLoadDurationProvider>
    </div>
  );
}
